module.exports = __webpack_public_path__ + "static/media/close.586bb873.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/home-navbar/close.svg
// module id = 406
// module chunks = 0 1 2